const WORKER_URL = "https://api-worker.erashidi.workers.dev/api/youtube";

export interface DownloadRequest {
    videoId: string;
    itag: number;
}

export interface DownloadResponse {
    success: boolean;
    data?: {
        url: string;
        filename: string;
        mimeType: string;
    };
    error?: string;
}

export const downloadVideo = async (request: DownloadRequest): Promise<DownloadResponse> => {
    try {
        const response = await fetch(`${WORKER_URL}/download`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(request),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        return {
            success: false,
            error: error instanceof Error ? error.message : "خطا در دانلود",
        };
    }
};
